import { CREATE_WEBHOOK, FETCH_INTEGRATIONS, REMOVE_WEBHOOK, UPDATE_WEBHOOK } from '@/store/types/actions';
import { INTEGRATIONS_FETCHED, WEBHOOK_CREATED, WEBHOOK_REMOVED, WEBHOOK_UPDATED } from '@/store/types/mutations';
import { apolloSdk } from '../../api/apollo';

const isWebhookType = (integration) => integration.__typename === 'IntegrationWebhook';
const toWebhookInput = (input) => ({
  name: input.name,
  url: input.url,
  method: input.method,
  headers: input.headers && input.headers.length
    ? input.headers
    : null,
  body: input.body
    ? input.body
    : null,
});

const actions = {
  async [FETCH_INTEGRATIONS]({ commit }, accountId) {
    const response = await apolloSdk.Integrations({ accountId });
    return commit(INTEGRATIONS_FETCHED, response.node.integrations);
  },
  async [CREATE_WEBHOOK]({ commit }, { accountId, webhook }) {
    const input = toWebhookInput(webhook);
    const response = await apolloSdk.AddIntegrationWebhook({ accountId, input });
    return commit(WEBHOOK_CREATED, response.addIntegrationWebhook.integration);
  },
  async [UPDATE_WEBHOOK]({ commit }, { id, ...webhook }) {
    const input = {
      ...toWebhookInput(webhook),
      version: webhook.version,
    };
    const response = await apolloSdk.UpdateIntegrationWebhook({ nodeId: id, input });
    return commit(WEBHOOK_UPDATED, response.updateIntegrationWebhook.integration);
  },
  async [REMOVE_WEBHOOK]({ commit }, id) {
    const response = await apolloSdk.RemoveIntegrationWebhook({ nodeId: id });
    return commit(WEBHOOK_REMOVED, response.removeIntegrationWebhook.integration);
  },
};

const mutations = {
  [INTEGRATIONS_FETCHED](state, integrations) {
    state.integrations.webhooks = integrations.filter(isWebhookType);
  },
  [WEBHOOK_CREATED](state, integration) {
    state.integrations.webhooks.push(integration);
  },
  [WEBHOOK_UPDATED](state, integration) {
    const index = state.integrations.webhooks.findIndex((m) => m.id === integration.id);
    state.integrations.webhooks.splice(index, 1, integration);
  },
  [WEBHOOK_REMOVED](state, integration) {
    const index = state.integrations.webhooks.findIndex((m) => m.id === integration.id);
    state.integrations.webhooks.splice(index, 1);
  },
};

const getters = {
  webhooks: (state) => state.integrations.webhooks,
};

const state = {
  integrations: {
    webhooks: [],
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
